module.exports = __webpack_public_path__ + "img/gold.eafc4f11.png";